import * as z from "zod";

export const mergeWorkOrders = {
  name: "mergeWorkOrders" as const,
  input: z.object({ workOrderIds: z.array(z.string()).min(2) }),
  output: z.object({ mergedWorkOrderId: z.string() }),
};
